<template>
  <SlideSidebarContainer>
    <div slot="title" class="d-flex align-items-center">
      <UserAvatar :user="user" class="mr-2" style="flex: 0 0 auto"/>
      <span>cursos de {{ user.name }}</span>
    </div>

    <UserProfileCoursesIndex :user="user" :per-page="15">
      <template v-slot="{ courses }">
        <UserProfileCoursesList :courses="courses"/>
      </template>
    </UserProfileCoursesIndex>
  </SlideSidebarContainer>
</template>

<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import UserProfileCoursesIndex from '@/components/user/profile/UserProfileCoursesIndex'
  import UserProfileCoursesList from '../../../../user/profile/UserProfileCoursesList.vue'
  import UserAvatar from '@/components/user/UserAvatar'
  
  export default {
    components: {
      SlideSidebarContainer,
      UserProfileCoursesIndex,
      UserProfileCoursesList,
      UserAvatar,
    },

    props: {
      user: { type: Object, required: true }
    }
  }
</script>